var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"feedBack-nav"},[_c('el-breadcrumb',{staticClass:"nav-bread",attrs:{"separator":"/"}},_vm._l((_vm.navData),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":item.to ? item.to : null}},[_vm._v(_vm._s(item.name))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }